export const LOAD = 'load';
export const CLICK = 'click';
export const SL = 'screen__load';
export const BC = 'button__continue';
export const OC = 'option__continue';
export const BS = 'button__scroll';
export const LR = 'link__redirect';
export const OR = 'option__redirect';
export const OS = 'option__select';

export const ONBOARDING_START = 'onboarding_start';
export const LEAD = 'lead';
export const CHECKOUT_SCREEN_LOAD = 'checkout_screen_load';
export const UPSELL_PURCHASED = 'upsell_purchase_completed';

export const PROCESSING_STARTED = 'processing_started';
export const SESSION_START = 'session_start';
export const CHECKOUT_SHOWN = 'subs_purchase_show';
export const BUY_SUBSCRIPTION_TAPPED = 'subs_purchase_started';
export const SUBSCRIBED = 'subs_purchase_completed';
export const INAPP_PURCHASE_COMPLETED = 'inapp_purchase_completed';
export const INAPP_PURCHASE_FAILED = 'inapp_purchase_failed';
export const PAYMENT_DECLINE = 'subs_purchase_failed';
export const POPUP_EVENT = 'payment_successful_popup';
export const INAPP_POPUP_EVENT = 'inapp_payment_successful_popup';
export const PAYWALL_CLOSED = 'subs_purchase_screen_close';
export const EMAIL_CONSENT_YES = 'email_consent_yes';
export const EMAIL_CONSENT_NO = 'email_consent_no';
export const GTM_LOAD_TIMEOUT = 'gtm_load_timeout';
export const GTM_NOT_CONFIGURED = 'gtm_not_configured';
